<template>
  <form-group class="ma-0 pa-0">
    <v-row>
      <v-col cols="12">
        <v-row justify="start">
          <v-col cols="6">
            <v-checkbox
              id="input:sendPush"
              :value="!sendPush"
              :loading="loading"
              label="Não quero enviar push"
              @change="v => handleSendPush(!v)"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              id="input:isPushHtml"
              v-model="isPushHtml"
              :loading="loading"
              label="Usar mensagem HTML personalizada"
            />
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col cols="9">
            <input-text
              id="input:titlePush"
              v-model="payload.title"
              :loading="loading"
              v-bind="required([maxLength(20)])"
              label="Título do push"
              counter="20"
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="mb-6">
          <v-col cols="12">
            <v-textarea
              id="input:bodyPush"
              ref="bodyPush"
              v-model="payload.body"
              :loading="loading"
              label="Mensagem do push"
              v-bind="required([maxLength(160)])"
              rows="5"
              counter="160"
              outlined
            />
            <v-row
              v-if="isPushHtml && payload.bodyHtml"
              justify="end"
              align="center"
              class="py-6"
            >
              <preview-modal
                v-model="payload.bodyHtml"
              />
            </v-row>
            <editor-code
              v-if="isPushHtml"
              class="my-4"
              :code="payload.bodyHtml"
              @update-code="code => payload.bodyHtml = code"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="9">
            <input-radio
              id="input:isAppRoute"
              v-model="isAppRoute"
              label="Rotas do aplicativo"
              :options="routesOptions"
              row
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:appRouteId"
              v-model="payload.routeId"
              :items="routes"
              :loading="routesLoading"
              :disabled="!isAppRoute"
              :rules="isAppRoute ? [requiredRule] : []"
              label="Rotas"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:subRoute"
              v-model="payload.subRoute"
              :disabled="!isAppRoute"
              :loading="loading"
              label="Sub-rota"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import PreviewModal from '@/app/arch/components/modals/PreviewModal.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import RoutesRequest from '@/app/modules/contacard/banners/banner_routes/RoutesRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';

export default {
  name: 'NotificationPushContent',
  components: { FormGroup, PreviewModal },
  mixins: [RulesMixin, RequestSelectMixin],
  data: () => ({
    requestClass: RoutesRequest,
    isPushHtml: '',
    isAppRoute: '',
    routes: [],
    routesLoading: false,
    routesMessageError: 'Falha ao buscar rotas',
    routesOptions: [
      {
        label: 'Sem rota',
        value: false,
        color: 'primary',
      },
      {
        label: 'Usar rota',
        value: true,
      },
    ],
  }),
  computed: {
    payload() {
      return this.notification.payload.push;
    },
    sendPush() {
      return this.notification.payload.sendPush;
    },
    required() {
      return (rules = []) => (
        this.sendPush
          ? {
            required: true,
            rules: [this.requiredRule, ...rules],
          }
          : {});
    },
    handleSendPush() {
      return (bool) => this.handleSelectedMessage('sendPush', bool);
    },
    loading() {
      return this.notification.loading;
    },
  },
  watch: {
    isAppRoute: {
      immediate: true,
      handler(value) {
        if (this.isBool(value)) {
          if (value) {
            this.getRoutes();
          } else {
            this.payload.push.routeId = '';
          }
        }
      },
    },
  },
  methods: {
    getRoutes() {
      this.handleRoutesLoading();
      this.makeRoutesRequest();
    },
    handleRoutesLoading() {
      this.routesLoading = !this.routesLoading;
    },
    makeRoutesRequest() {
      if (!this.routes.length) {
        this.prepareRequest();
      } else {
        this.handleRoutesLoading();
      }
    },
    prepareRequest() {
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions('routes', 'name'),
        this.routesMessageError,
        this.handleRoutesLoading,
      );
    },
  },
  inject: {
    notification: {
      default() {
        return {
          payload: {
            push: {
              title: '',
              body: '',
              routeId: '',
              subRoute: '',
              bodyHtml: '',
              communicationId: '',
              isDraft: false,
            },
            sendPush: '',
          },
          loading: '',
        };
      },
    },
    handleSelectedMessage: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
